export default __webpack_public_path__ + "static/media/annuity-icon-48px.fb0260ed.svg";